import { useEffect, useState } from "react";
import customerService from "../../services/customer/customerService";
import "./inscrit.css";
import { useHistory } from "react-router-dom";
import { useGoogleLogin } from "react-google-login";
import FacebookLogin from "react-facebook-login";
import { saveUser } from "../CreateUser/store/userAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import NavBarHome from "../home/NavBarHome";
import Footer from "../Footer/Footer";
import familyService from "../../services/family/familyService";
import { BsGoogle } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import { gapi } from "gapi-script";
import DocumentMeta from "react-document-meta";
import contractService from "../../services/contract/contractService";
const AssurMax = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [forgetPass, setForgetPass] = useState(false);
  const [status, setStatus] = useState(true);
  const [user,setUser] = useState({})
  const [gotocardreg, setGotocardreg] = useState(false);
  const [tophonecheck, setTophonecheck]= useState(false)
  const [tocallcenter, setTocallcenter]= useState(false)
  const [toValidateCode, setToValidateCode]= useState(false)
  
  
  
  window.gapi.load("client:auth2", () => {
    window.gapi.client.init({
      clientId:
        "602346386490-sbctad5pa4o07ppilp8a4i837eif6srd.apps.googleusercontent.com",
      plugin_name: "chat",
    });
  });
  const clientId =
    "602346386490-sbctad5pa4o07ppilp8a4i837eif6srd.apps.googleusercontent.com";
  const [dto, setDto] = useState({
    number: "",
  });
  const [dtoPhone, setDtoPhone] = useState({
    phone: "",
  });
  const [otpCode, setOtpCode] = useState({
    code: "",
  });
  
  const formule = useSelector(({ userReducer }) => userReducer.formule);
  const [familyList, setFamilyList] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    familyService.getAllFamily().then((res) => {
      setFamilyList(res.data.sort((a, b) => a.displayOrder - b.displayOrder).filter((elem, i) => elem.displayOrder < 4 ));
    });
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDto((dto) => ({ ...dto, [name]: value }));
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setDtoPhone((dtoPhone) => ({ ...dtoPhone, [name]: value }));
  };

  const handleChange3 = (e) => {
    const { name, value } = e.target;
    setOtpCode((otpCode) => ({ ...otpCode, [name]: value }));
  };

  const onSubmit = () => {
    setForgetPass(true);
  };
  const responseFacebook = (res) => {
    let name = res.name.split(" ");
    customerService
      .createFacebookCustomer({
        email: res.email,
        firstName: name[0],
        lastName: name[1],
        facebookid: res.userID,
      })
      .then((res) => {
        if (res.status == 200) {
          localStorage.setItem("user", JSON.stringify(res.data));
          history.push("/dashboard");
        } else if (res.status == 202) {
          localStorage.setItem("user", JSON.stringify(res.data));
          history.push("/dashboard");
        }
      });
  };
  const onSuccess = (res) => {
    customerService
      .createGoogleCustomer({
        email: res.profileObj.email,
        firstName: res.profileObj.givenName,
        lastName: res.profileObj.familyName,
        googleid: res.profileObj.googleId,
      })
      .then((res) => {
        if (res.status == 200) {
          localStorage.setItem("user", JSON.stringify(res.data));
          history.push("/dashboard");
        } else if (res.status == 202) {
          localStorage.setItem("user", JSON.stringify(res.data));
          history.push("/dashboard");
        }
      });
  };
  const onFailure = (res) => {
    console.log("login Failure:", res.details);
  };
  const checkcardnumber = ()=>{
    contractService.loginWithCardNumber(dto.number).then((res)=>{
        if(res.data === 1){
            setTophonecheck(true)
            setGotocardreg(false)
        }else if(res.data === 2 ){
            setTocallcenter(true)
            setGotocardreg(false)
        }
        
    })
  }
   const checkphonenumber = ()=>{
    contractService.checkPhoneNumber(dto.number, dtoPhone.phone).then((res)=>{
        if(res.data.result === 1){
          setUser(res.data.customer)
          localStorage.setItem("user", JSON.stringify({email:res.data.customer.email , id : res.data.customer.idcustomer }));
          // history.push("/dashboard");
          customerService.sendCode(res.data.customer.idcustomer).then(res=>{
            if(res.status === 200){

              setToValidateCode(true)
              setTophonecheck(false)
            }
          })
        }
        
    }).catch((Error)=>{
        if(Error){
            setTocallcenter(true)
            setTophonecheck(false)
        }
        
    })
  }
  const checkOtp = ()=>{
    customerService
        .checkCodeConfirmation({cin :user.cin ,code : otpCode.code , phone : dtoPhone.phone}).then((res)=>{
        if(res.status === 200){
          history.push("/dashboard");
            setToValidateCode(true)
            setTophonecheck(false)
        }
        
    }).catch((Error)=>{
        if(Error){
            setTocallcenter(true)
            setTophonecheck(false)
        }
        
    })
  }
  const seConnecter = async (e) => {
   setGotocardreg(true)
   setStatus()
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      seConnecter(e);
    }
  };
   const meta = {
    title: "Se connecter à Garanty",
    description:
    "Connectez-vous à Garanty pour accéder à votre espace personnel et gérer facilement vos garanties en toute sécurité.",
    canonical: "https://garanty.tn/connexion",
    meta: {
      charset: "utf-8",
      'http-equiv': {
        'cache-control': 'no-cache, must-revalidate, post-check=0, pre-check=0',
        expires: '0',
        pragma: 'no-cache',
      },
      name: {
        keywords: "react,meta,document,html,tags",
      },
    },
  };
  return (
    <DocumentMeta {...meta} className="container-fluid">
      <NavBarHome dark relative />
      <div className="body-inscrit">
        <h1
          style={{
            fontFamily: "Century Gothic",
            fontSize: "30px",
            textAlign: "center",
            fontWeight: "bold",
            color: "#0C015F",
            marginTop: "7%",
          }}
        >
          {forgetPass ? "Mot de passe oublié" : "Garanty AssurMax"}
        </h1>
        {status && <>
            <div
            className="row col-md-12 col-lg-12 col-sm-12"
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2%",
            }}
            >
            <div
                className="col-sm-6 col-md-4 col-lg-4"
                style={{ display: "flex", justifyContent: "center" }}
            >
                <div className="connect-btn">
                <button
                    className="connect-btn"
                    id="connecter"
                    onClick={seConnecter}
                    style={{fontSize:"20px"}}
                >
                    Activer votre Carte
                </button>
                </div>
            </div>
            </div>
            <div
            className="row col-md-12 col-lg-12 col-sm-12"
            style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2%",
            }}
            >
            <div
                className="col-sm-6 col-md-4 col-lg-4"
                style={{ display: "flex", justifyContent: "center" }}
            >
                <div className="connect-btn">
                <button
                    className="connect-btn"
                    id="connecter"
                    onClick={seConnecter}
                    style={{fontSize:"20px"}}
                >
                    Acceder a mon espace AssurMax
                </button>
                </div>
            </div>
            </div>
        </>}
       { gotocardreg && <div
          className="row col-md-12 col-lg-12 col-sm-12 col-lg-12 col-sm-12"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <div
            className="col-sm-6 col-md-4 col-lg-4 aide"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                textAlign: "left",
                font: "normal normal bold 14px/26px Century Gothic",
                letterSpacing: "0px",
                color: "#000000",
                opacity: "1",
                marginLeft: "4%",
                marginBottom: "13px",
                width: "300px"
              }}
            >
              Numéro de la Carte:{"                   "}<span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="number"
              type="text"
              className="login"
              placeholder="Entrer votre Numéro Carte"
              value={dto.number}
              onChange={handleChange}
            />
          </div>
          
        </div>
        
        }
        { gotocardreg && <div className="row col-md-6 col-lg-8 col-sm-8 socialmedia-div">
                  <div
                    className="col-sm-6 col-md-4 col-lg3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="connect-btn"
                      style={{
                        backgroundColor: "#ff2f19",
                        // border: "1px solid #ff2f19",
                        color: "white",
                        fontSize: "15px",
                        marginTop: "3px",
                      }}
                    >
                      <button
                        className="connect-btn"
                        onClick={checkcardnumber}
                        style={{
                          backgroundColor: "#ff2f19",
                          // border: "1px solid #ff2f19",
                          color: "white",
                          fontSize: "15px",
                          justifyContent: "center",
                        }}
                      >
                        Suivant
                      </button>
                    </div>
                  </div>
        </div>}
        { tophonecheck && <div
          className="row col-md-12 col-lg-12 col-sm-12 col-lg-12 col-sm-12"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <div
            className="col-sm-6 col-md-4 col-lg-4 aide"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <label
              style={{
                textAlign: "left",
                font: "normal normal bold 14px/26px Century Gothic",
                letterSpacing: "0px",
                color: "#000000",
                opacity: "1",
                marginLeft: "4%",
                marginBottom: "13px",
              }}
            >
              Veuillez saisir le numéro de téléphone utilisé lors de la souscription: <span style={{ color: "red" }}>*</span>
            </label>
            <input
               style={{width:"300px"}}
              name="phone"
              type="text"
              className="login"
              placeholder="Numéro téléphone"
              value={dtoPhone.phone}
              onChange={handleChange2}
            />
          </div>
          
        </div>
        
        }
        { tophonecheck && <div className="row col-md-6 col-lg-8 col-sm-8 socialmedia-div">
                  <div
                    className="col-sm-6 col-md-4 col-lg3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="connect-btn"
                      style={{
                        backgroundColor: "#ff2f19",
                        // border: "1px solid #ff2f19",
                        color: "white",
                        fontSize: "15px",
                        marginTop: "3px",
                      }}
                    >
                      <button
                        className="connect-btn"
                        onClick={checkphonenumber}
                        style={{
                          backgroundColor: "#ff2f19",
                          // border: "1px solid #ff2f19",
                          color: "white",
                          fontSize: "15px",
                          justifyContent: "center",
                        }}
                      >
                        Suivant
                      </button>
                    </div>
                  </div>
        </div>}

        { toValidateCode && <div
          className="row col-md-12 col-lg-12 col-sm-12 col-lg-12 col-sm-12"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <div
            className="col-sm-6 col-md-4 col-lg-4 aide"
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                textAlign: "left",
                font: "normal normal bold 14px/26px Century Gothic",
                letterSpacing: "0px",
                color: "#000000",
                opacity: "1",
                marginLeft: "4%",
                marginBottom: "13px",
              }}
            >
              Saisissez le code OTP reçu par SMS:<span style={{ color: "red" }}>*</span>
            </label>
            <input
              name="code"
              type="text"
              className="login"
              placeholder="OTP code"
              value={otpCode.code}
              onChange={handleChange3}
            />
          </div>
          
        </div>
        
        }
        { toValidateCode && <div className="row col-md-6 col-lg-8 col-sm-8 socialmedia-div">
                  <div
                    className="col-sm-6 col-md-4 col-lg3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div
                      className="connect-btn"
                      style={{
                        backgroundColor: "#ff2f19",
                        // border: "1px solid #ff2f19",
                        color: "white",
                        fontSize: "15px",
                        marginTop: "3px",
                      }}
                    >
                      <button
                        className="connect-btn"
                        onClick={checkOtp}
                        style={{
                          backgroundColor: "#ff2f19",
                          // border: "1px solid #ff2f19",
                          color: "white",
                          fontSize: "15px",
                          justifyContent: "center",
                        }}
                      >
                        Suivant
                      </button>
                    </div>
                  </div>
        </div>}

      { tocallcenter && <h3
          style={{
            textAlign: "center",
            fontFamily: "Century Gothic",
            fontSize: "17px",
            marginTop: "18px",
            fontWeight: "bold",
            color: "red"
          }}
        >
          Veuiller contacter le service client pour plus d'informations
        </h3>}
      </div>
      <div className="row col-md-12 col-lg-12 col-sm-12 col-lg-12 col-sm-12" style={{marginTop:"100px"}}>
        <div className="col-sm-6 col-md-4 col-lg-4"></div>
      </div>
      <Footer listFamily={familyList} />
    </DocumentMeta>
  );
};

export default AssurMax;
